import { useFormik } from "formik";
import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import {
  Col,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Row,
  Button,
} from "reactstrap";
import {
  UPDATE_ADMIN_USER,
  UPDATE_AGENCY_USER,
  UPLOAD_FILE,
} from "../../../constants/ApiPaths";
import { authHeader, authUserRole } from "../../../functions/CoreFunctions";
import { CustomAlertMessage } from "../../../functions/CustomFunctions";
import {
  AgencygetLoggedUserDetails,
} from "../../../redux/actions";
import API from "../../../redux/actions/API";
import { getAdminUserId } from "../../common/CommonFunctions";
import * as Yup from "yup";
import CustomButtonLoader from "../../CustomComponents/CustomButtonLoader";
import { useDispatch, useSelector } from "react-redux";
import CustomPageLoading from "../../CustomComponents/CustomPageLoading";
import defaultAvatar from "../../../constants/Images/defaultAvatar-1.png";

export default function MyProfile() {
  const [loading, setLoading] = useState(false);
  const [imageLoading, setImageLoading] = useState(false);
  const Delete = useSelector((state) => state.Agencydelete);

  const { enqueueSnackbar } = useSnackbar();

  const dispatch = useDispatch();

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "+1 ",
    profileImage: defaultAvatar,
    agencyId: 0,
    agencyName: "",
    agencyUrl: "",
    city: "",
    createdBy: "",
    createdDate: "",
    dateOfBirth: "",
    gender: "",
    isDefaultPassword: "",
    isRootUser: "",
    stateId: "",
    zip: "",
    stateName: "",
  });
  const reduxState = useSelector((state) => state.AuthUserDetailsReducer);
  useEffect(() => {
    const {
      firstName,
      lastName,
      email,
      phoneNumber,
      profileImage = "",
      agencyId,
      agencyName,
      agencyUrl,
      city,
      createdBy,
      createdDate,
      dateOfBirth,
      gender,
      isDefaultPassword,
      isRootUser,
      stateId,
      zip,
      stateName,
    } = reduxState;
    setFormData({
      firstName: firstName,
      lastName: lastName,
      email: email,
      phoneNumber: "+1 ".concat(phoneNumber),
      profileImage: profileImage,
      agencyId,
      agencyName,
      agencyUrl,
      city,
      createdBy,
      createdDate,
      dateOfBirth,
      gender,
      isDefaultPassword,
      isRootUser,
      stateId,
      zip,
      stateName,
    });
  }, [reduxState]);
  // validation schema
  Yup.addMethod(Yup.string, "phoneNumberValidation", function (errorMessage) {
    return this.test(`test-card-type`, errorMessage, function (value) {
      const { path, createError } = this;
      if (value) {
        let v1 = value;
        if (value.includes("+1 ")) {
          v1 = value.split("+1 ")[1];
        } else {
          // Handle the case where "+1 " is not present
          v1 = value;
        }

        const num = v1.replace(/\D+/g, "");
        const check = v1.match(/[A-Za-z_@./#&+!^*+=,:;]/) ? false : true;
        const Pass = num.length <= 10;
        return (check && Pass) || createError({ path, message: errorMessage });
      } else {
        return createError({ path, message: "Phone Number is Required" });
      }
    });
  });
  const validationSchema = Yup.object({
    firstName: Yup.string().trim().required("First Name is required"),
    lastName: Yup.string().trim().required("Last Name is required"),
    email: Yup.string().trim().required("Email is required"),
    phoneNumber: Yup.string().phoneNumberValidation("Invalid Phone Number"),
  });
  const saveFormValues = async (values) => {
    if (Delete) return;

    const userId = getAdminUserId();
    const { profileImage } = formData;
    values.profileImage = profileImage;
    setLoading(true);
    const config = {
      method: "PUT",
      url:
        authUserRole() === "Root Admin" ? UPDATE_ADMIN_USER : UPDATE_AGENCY_USER,
      data: {
        ...values,
        userId: userId,
        phoneNumber: values.phoneNumber.includes("+1")
          ? values.phoneNumber.split("+1 ")[1]
          : values.phoneNumber,
      },
      headers: authHeader(),
    };

    try {
      const response = await API(config);
      const { status } = response.data;

      if (status === "Success") {
        CustomAlertMessage(
          "Profile Updated Successfully!",
          "success",
          enqueueSnackbar
        );

        dispatch(AgencygetLoggedUserDetails(userId));
      }
    } catch (error) {
      const { data } = error.response;

      CustomAlertMessage(data.message, "error", enqueueSnackbar);
    } finally {
      setLoading(false);
    }
  };
  //Formik
  const { handleSubmit, handleChange, values, errors, touched, handleBlur } =
    useFormik({
      initialValues: formData,
      enableReinitialize: true,
      validationSchema,
      onSubmit: (values) => saveFormValues(values),
    });

  const choosenImage = async (event) => {
    const file = new FormData();
    file.append("file", event.target.files[0]);
    if (!event.target.files[0]) return;
    setImageLoading(true);
    const config = {
      method: "POST",
      url: UPLOAD_FILE,
      headers: authHeader(),
      data: file,
      "content-type": "multipart/form-data",
    };

    try {
      const response = await API(config);
      const { filePath, status } = response.data;
      if (status === "Success") {
        setFormData({
          ...formData,
          profileImage: filePath,
        });
      }
    } catch (error) {
      console.error(error);
      const { data } = error.response;

      CustomAlertMessage(data.message, "error", enqueueSnackbar);
    } finally {
      setImageLoading(false);
    }
  };

  return (
    <Form form="true" onSubmit={handleSubmit}>
      <div className="page">
        <Row>
          <Col md="4">
            {imageLoading && <CustomPageLoading />}

            <div className="user-box">
              <img src={values.profileImage} alt=""/>
              <p>Edit Profile Picture</p>

              <div className="upload-btn-wrapper">
                <button className="upload-btn">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="19.407"
                    height="16.981"
                    viewBox="0 0 19.407 16.981"
                  >
                    <path
                      id="Icon_awesome-camera"
                      data-name="Icon awesome-camera"
                      d="M19.407,6.5V17.412a1.82,1.82,0,0,1-1.819,1.819H1.819A1.82,1.82,0,0,1,0,17.412V6.5A1.82,1.82,0,0,1,1.819,4.676H5.155l.466-1.247a1.817,1.817,0,0,1,1.7-1.179H12.08a1.817,1.817,0,0,1,1.7,1.179l.47,1.247h3.336A1.82,1.82,0,0,1,19.407,6.5Zm-5.155,5.458A4.549,4.549,0,1,0,9.7,16.5,4.552,4.552,0,0,0,14.252,11.954Zm-1.213,0A3.336,3.336,0,1,1,9.7,8.618,3.341,3.341,0,0,1,13.039,11.954Z"
                      transform="translate(0 -2.25)"
                      fill="#d51d1d"
                    />
                  </svg>
                </button>
                <input
                  type="file"
                  name="profileImage"
                  accept=".png, .jpg"
                  onChange={choosenImage}
                />
              </div>
            </div>
          </Col>

          <Col md="4">
            <FormGroup>
              <Label for="">First Name</Label>
              <Input
                type="text"
                name="firstName"
                id="firstName"
                placeholder="Enter First Name"
                value={values.firstName}
                invalid={errors.firstName && touched.firstName ? true : false}
                onChange={handleChange}
              />
              <FormFeedback>
                {errors.firstName && touched.firstName ? errors.firstName : ""}
              </FormFeedback>
            </FormGroup>

            <FormGroup>
              <Label for="">Email</Label>
              <Input
                type="text"
                name="email"
                id="email"
                value={values.email}
                onBlur={handleBlur}
                invalid={errors.email && touched.email ? true : false}
                onChange={handleChange}
                placeholder="Enter Email "
                disabled={true}
              />
              <FormFeedback>
                {errors.email && touched.email ? errors.email : ""}
              </FormFeedback>
            </FormGroup>
          </Col>

          <Col md="4">
            <FormGroup>
              <Label for="">Last Name</Label>
              <Input
                type="text"
                name="lastName"
                id="lastName"
                value={values.lastName}
                onBlur={handleBlur}
                invalid={errors.lastName && touched.lastName ? true : false}
                onChange={handleChange}
                placeholder="Enter Last Name"
              />
              <FormFeedback>
                {errors.lastName && touched.lastName ? errors.lastName : ""}
              </FormFeedback>
            </FormGroup>
            <FormGroup>
              <Label for="">Phone Number</Label>
              <Input
                type="text"
                name="phoneNumber"
                id="phoneNumber"
                placeholder="Enter  Phone Number"
                value={values.phoneNumber}
                onBlur={handleBlur}
                invalid={
                  errors.phoneNumber && touched.phoneNumber ? true : false
                }
                onChange={handleChange}
              />
              <FormFeedback>
                {errors.phoneNumber && touched.phoneNumber
                  ? errors.phoneNumber
                  : ""}
              </FormFeedback>
            </FormGroup>

            <div className="top-btn">
              <Button
                disabled={Delete}
                type="submit"
                className="ml-auto d-block"
                color="primary"
              >
                {loading && <CustomButtonLoader loading={loading} />}
                Save Changes
              </Button>
            </div>
          </Col>
        </Row>
      </div>
    </Form>
  );
}
